import { useState, useEffect } from 'react';
import { fetchEvents } from '../services/strapiService';

export const useFeaturedEvents = (limit = 25) => {
  const [events, setEvents] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const loadEvents = async () => {
      try {
        setLoading(true);
        const allEvents = await fetchEvents();
        
        // 🔍 DEBUG: Vediamo com'è strutturato il primo evento
        if (allEvents.length > 0) {
          console.log('🔍 PRIMO EVENTO dal strapiService:', allEvents[0]);
          console.log('🖼️ CAMPO IMAGE:', allEvents[0].image);
          console.log('🖼️ TIPO IMAGE:', typeof allEvents[0].image);
          if (Array.isArray(allEvents[0].image)) {
            console.log('📸 PRIMA IMMAGINE:', allEvents[0].image[0]);
          }
        }
        
        // Data di oggi alle 00:00:00 per confronto
        const today = new Date();
        today.setHours(0, 0, 0, 0);
        
        // Filtra solo eventi futuri e attivi
        const futureEvents = allEvents
          .filter(event => {
            // Controlla se l'evento è attivo
            if (!event.isActive || event.isExpired) return false;
            
            // Controlla la data dell'evento
            const eventDate = new Date(event.startDate || event.date);
            eventDate.setHours(0, 0, 0, 0);
            
            // Include solo eventi da oggi in poi
            return eventDate >= today;
          })
          .sort((a, b) => new Date(a.startDate || a.date) - new Date(b.startDate || b.date))
          .slice(0, limit);
          
        console.log(`✅ Eventi futuri caricati: ${futureEvents.length}`);
        setEvents(futureEvents);
        setError(null);
      } catch (err) {
        console.error('Errore nel caricamento eventi:', err);
        setError(err);
      } finally {
        setLoading(false);
      }
    };

    loadEvents();
  }, [limit]);

  return { events, loading, error };
};
